import XLSX from 'xlsx';
import { FILE_SIZES } from 'Common/enums';

import { validateCsvHeaders } from '../../sheetjs-helpers';

type ValidationHeaderType = {
    slicedFileData: Uint8Array;
    requiredColumns: ImporterColumn[];
};

export type ImporterValidatedObjType = {
    difference: string[][];
    isEmptyFile?: boolean;
};

/** Handles Validating Headers of CSV */
const handleValidatingFileHeaders = ({ slicedFileData, requiredColumns }: ValidationHeaderType) => {
    const workBook = XLSX.read(slicedFileData, { type: 'array', bookVBA: true, sheetRows: 5 });
    const [sheetName] = workBook.SheetNames;
    const workSheet = workBook.Sheets[sheetName];
    const { difference, isEmptyFile } = validateCsvHeaders(workSheet, requiredColumns);
    return { difference, isEmptyFile };
};

/** Reads CSV file as array buffer, convert to array with only first few rows as we only have header validation
 * @param `file` File to be read and validated
 * @param `requiredColumns` required columns to be validated against data
 */
export const readFileForValidation = async (
    file: File,
    requiredColumns: ImporterColumn[]
): Promise<ImporterValidatedObjType> => {
    const reader = new FileReader();
    if (file) {
        reader.readAsArrayBuffer(file);
    }
    const result = await new Promise<ImporterValidatedObjType>((resolve) => {
        reader.onload = (e) => {
            const data = e.target?.result;
            const fileAsArray = new Uint8Array(data as Buffer);
            const slicedFileData = fileAsArray.slice(0, FILE_SIZES['2 MB']);

            if (data) {
                const validationObj: ImporterValidatedObjType = handleValidatingFileHeaders({
                    slicedFileData,
                    requiredColumns
                });
                resolve(validationObj);
            }
        };
    });
    return result;
};
